import { useParams } from 'react-router-dom';
import { SubPageLayout } from '../../../../sub-page-layout';
import { TransactionsContainer } from '../components/transactions.container.tsx';
import { Helmet } from 'react-helmet';

export const TransactionsSendReport: React.FC = () => {
  const params = useParams();
  return (
    <div style={{ marginTop: '25px' }}>
      <Helmet>
        <title>Case - Transactions</title>
      </Helmet>
      <SubPageLayout title="Transaction Summary">
        <TransactionsContainer caseId={params['caseId'] ?? ''} />
      </SubPageLayout>
    </div>
  );
};
